// Functional parity helpers split from MapSection.js; keep map rendering in the component.
import L from "leaflet";

// === LABEL_PRINT_FUNCTION_START ===
function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function hasRequiredMeasurement(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
}

export function hasPointDataEntryForLabel(point) {
  if (!point) return false;
  if (point.hasDataEntry || point.veriGirisiTimestamp) return true;

  const measurementValues = [
    point.sicaklik,
    point.atm,
    point.spc,
    point.tds,
    point.sal,
    point.ph,
    point.notMetni,
  ];

  if (measurementValues.some(hasRequiredMeasurement)) return true;

  const customMeasurements =
    point.customMeasurements && typeof point.customMeasurements === "object"
      ? Object.values(point.customMeasurements)
      : [];
  if (customMeasurements.some(hasRequiredMeasurement)) return true;

  if (Array.isArray(point.photoDataUrls) && point.photoDataUrls.some(hasRequiredMeasurement)) {
    return true;
  }

  return hasRequiredMeasurement(point.photoDataUrl);
}

export function printTwoLabels(text) {
  const win = window.open("", "_blank");
  if (!win) {
    alert(
      "Tarayıcı yazdırma penceresini engelledi. Lütfen bu site için açılır pencereye (pop-up) izin verin ve tekrar deneyin."
    );
    return;
  }
  const safeText = escapeHtml(text);

  const baseHead = `
    <head>
      <style>
        @page {
          margin: 8mm;
        }
        body {
          margin: 0;
          padding: 0;
          font-family: Arial, sans-serif;
          text-align: center;
        }
        .label {
          width: 100%;
          min-height: 30mm;
          padding: 8mm 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
        }
        .code {
          font-size: 20px;
          margin-top: 6px;
          word-break: break-word;
        }
        .label--break {
          page-break-after: always;
        }
        @media print {
          .label--break {
            break-after: page;
          }
        }
      </style>
    </head>
  `;

  win.document.open();
  win.document.write(`
    <html>
      ${baseHead}
      <body>
        <div class="label label--break">
          <div class="title">ASİTLİ</div>
          <div class="code">${safeText}</div>
        </div>
        <div class="label">
          <div class="title">ASİTSİZ</div>
          <div class="code">${safeText}</div>
        </div>
      </body>
    </html>
  `);
  win.document.close();
  win.focus();
  setTimeout(() => {
    win.print();
    win.close();
  }, 150);
}
// === LABEL_PRINT_FUNCTION_END ===



export const ICON_COLORS = {
  pending: "#6c757d",
  Pozitif: "#28a745",
  Negatif: "#dc3545",
  Tekrar: "#ffc107",
  "Konum Güncellendi": "#f59e0b",
  "Konum Kaydırıldı": "#f59e0b",
  Yeni: "#2563eb",
  Bilinmiyor: "#6c757d",
  temp: "#ffffff",
  gps: "#0078ff",
};

export function getStatusLabel(status) {
  if (status === "pending") return "Beklemede";
  return status || "Bilinmiyor";
}

export function makeDivIcon({
  color = "#6c757d",
  size = 24,
  square = false,
  border = "#ffffff",
  borderWidth = 2,
  label = "",
  emoji = "",
} = {}) {
  const normalizeHexColor = (value) => {
    const text = String(value || "").trim();
    const shortHex = /^#([0-9a-f]{3})$/i.exec(text);
    if (shortHex) {
      const [r, g, b] = shortHex[1].split("");
      return `#${r}${r}${g}${g}${b}${b}`;
    }
    const fullHex = /^#([0-9a-f]{6})$/i.exec(text);
    return fullHex ? text : "#6c757d";
  };

  const getReadableTextColor = (hexColor) => {
    const hex = normalizeHexColor(hexColor).slice(1);
    const r = Number.parseInt(hex.slice(0, 2), 16);
    const g = Number.parseInt(hex.slice(2, 4), 16);
    const b = Number.parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? "#0f172a" : "#ffffff";
  };

  const badgeBgColor = normalizeHexColor(color);
  const badgeTextColor = getReadableTextColor(badgeBgColor);

  const borderRadius = square ? "3px" : "50%";
  const hasEmoji = Boolean(String(emoji || "").trim());
  const fontSize = hasEmoji ? Math.max(14, Math.round(size * 0.56)) : 10.5;
  const maxChars = size >= 30 ? 6 : size >= 24 ? 5 : 4;
  const maxBadgeChars = 4;
  const compactLabel = label
    ? String(label).trim().toUpperCase().slice(0, maxChars)
    : "";
  const compactEmoji = emoji ? String(emoji).trim() : "";
  const markerContent = compactEmoji || compactLabel;
  const tinyLabel = compactLabel.slice(0, maxBadgeChars);
  const labelBadge = hasEmoji && tinyLabel
    ? `<span style="
        position:absolute;
        left:50%;
        top:-22px;
        transform:translateX(-50%);
        min-width:18px;
        height:18px;
        border-radius:999px;
        padding:0 4px;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:10px;
        font-weight:800;
        color:${badgeTextColor};
        background:${badgeBgColor};
        border:1px solid rgba(255,255,255,0.72);
        box-shadow:0 1px 3px rgba(2,6,23,0.3);
        line-height:1;
      ">${tinyLabel}</span>`
    : "";
  const labelNeedle = hasEmoji && tinyLabel
    ? `<span style="
        position:absolute;
        left:50%;
        top:-5px;
        width:2px;
        height:9px;
        transform:translateX(-50%);
        background:#ffffff;
        border:1px solid rgba(15,23,42,0.2);
        border-radius:2px;
        box-shadow:0 1px 2px rgba(2,6,23,0.15);
      "></span>`
    : "";
  const pinTail = `<span style="
      position:absolute;
      left:50%;
      bottom:-8px;
      width:0;
      height:0;
      border-left:5px solid transparent;
      border-right:5px solid transparent;
      border-top:8px solid ${color};
      transform:translateX(-50%);
      filter:drop-shadow(0 1px 1px rgba(2,6,23,0.35));
    "></span>`;
  const html = `
    <div style="
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${size}px;
      height: ${size}px;
      background: ${color};
      border-radius: ${borderRadius};
      border: ${borderWidth}px solid ${border};
      box-shadow: 0 1px 3px rgba(0,0,0,0.3);
      color: #fff;
      font-size: ${fontSize}px;
      font-weight: 700;
      text-align: center;
      line-height: 1.05;
      white-space: nowrap;
      letter-spacing: 0.2px;
      text-shadow: 0 1px 2px rgba(0,0,0,0.55);
      box-sizing: border-box;
      padding: 0 2px;
      overflow: visible;
    ">
      ${markerContent}
      ${labelBadge}
      ${labelNeedle}
      ${pinTail}
    </div>
  `;
  return L.divIcon({
    className: "",
    html,
    iconSize: [size + 10, size + 24],
    iconAnchor: [(size + 10) / 2, size + 10],
  });
}

// Marker boyutu ve emoji eşlemesi harita görünümünü etkiler; parity için eski eşikler korunur.
function getMarkerSizeForZoom(zoom) {
  if (!zoom) return 24;
  if (zoom <= 10) return 26;
  if (zoom <= 12) return 25;
  if (zoom <= 14) return 24;
  if (zoom <= 16) return 23;
  return 22;
}

function normalizeSampleToken(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase("tr-TR");
}

export function getSampleEmoji(point) {
  const custom = point?.customMeasurements || {};
  const sampleType = normalizeSampleToken(
    custom.numuneTuru ||
      custom["Numune Türü"] ||
      point?.numuneTuru ||
      point?.numuneTuruAdi
  );
  const waterType = normalizeSampleToken(
    custom.suNumuneTuru ||
      custom["Su Türü"] ||
      custom.suTuru ||
      custom.suTipi ||
      custom["Su Numune Türü"] ||
      point?.suNumuneTuru ||
      point?.suTuru
  );

  if (sampleType === "su") {
    if (waterType.includes("kaynak")) return "💧";
    if (waterType.includes("kuyu")) return "💦";
    if (waterType.includes("akarsu")) return "🌊";
    if (waterType.includes("göl") || waterType.includes("gol")) return "🔵";
    return "💧";
  }

  if (sampleType === "toprak") return "🟫";
  if (sampleType === "dere sedimanı" || sampleType === "dere sedimani") return "🐠";
  if (sampleType === "bitki") return "🍀";
  if (sampleType === "posa" || sampleType === "pasa") return "♻️";
  if (sampleType === "kayaç" || sampleType === "kayac") return "⛰️";
  if (sampleType === "diğer" || sampleType === "diger") return "⭐";

  return "";
}

export function getIconForStatus(status, label = "", mapZoom, emoji = "") {
  const statusKey =
    status === "Konum Kaydırıldı" ? "Konum Güncellendi" : status;

  const color = ICON_COLORS[statusKey] || ICON_COLORS.pending;
  const baseSize = getMarkerSizeForZoom(mapZoom);
  const hasEmoji = Boolean(String(emoji || "").trim());
  const size = hasEmoji ? baseSize + 4 : baseSize - 1;

  if (statusKey === "Konum Güncellendi") {
    return makeDivIcon({
      color: "#22c55e",
      square: true,
      label,
      emoji,
      size,
      border: "#2563eb",
      borderWidth: 2,
    });
  }
  if (statusKey === "Yeni") {
    return makeDivIcon({ color, square: false, label, emoji, size, border: "#dbeafe" });
  }
  return makeDivIcon({ color, label, emoji, size });
}
